import { useAppSelector } from '@/Application/Hooks/Redux';
import type { IOrderConfirmation } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';

import { PaymentMethodCardPreview } from './payment-method-card-preview.component';

const ListPaymentMethods = () => {
  const billing = useAppSelector((state) => state.billing);
  const paymentSuccess = billing.paymentSuccess as IOrderConfirmation;

  const totalSummary = paymentSuccess?.totalSummary;
  const isCencoPay = paymentSuccess?.isCencoPay;
  const isCencoBalance = totalSummary?.summary?.wasPaidWithCencoPayBalance;

  return (
    <div className="co-w-full co-flex co-flex-col co-gap-16px lg:co-w-1/3">
      {totalSummary?.paymentMethod?.map((paymentMethod, index) => (
        <PaymentMethodCardPreview
          key={index}
          paymentMethod={paymentMethod}
          isCencoPayBalance={isCencoBalance}
          isCencoPay={isCencoPay}
        />
      ))}
    </div>
  );
};

export default ListPaymentMethods;
